import React, {useEffect, useState} from "react";
import styles from "./teamPageSquad.module.css"
import { useOutletContext } from "react-router-dom";
import { PersonShort } from "../../types/personTypes";
import PersonCard from "../personCard/personCard";
import fetchPersonsByTeam from "../../api/fetchPersonsByTeam";

const TeamPageSquad: React.FC = () => {
    const id = useOutletContext() as string;
    const [personsShort, setPersonsShort] = useState<PersonShort[]>([])

    const getPersonsShort = async () => {
        try {
            if (id) {
                const data = await fetchPersonsByTeam(BigInt(id))
                setPersonsShort(data)
            }
        } catch (error) {
            console.error('Error fetching short persons data:', error)
        }
    }

    useEffect(() => {
        getPersonsShort()
    }, [id])

    const goalkeepers = personsShort.filter(person => person.role === 'Goalkeeper')
    const defenders = personsShort.filter(person => person.role === 'Defender')
    const midfielders = personsShort.filter(person => person.role === 'Midfielder')
    const forwards = personsShort.filter(person => person.role === 'Forward')


    return (
        <div className={styles.team_container}>
            <h2>Goallkeepers</h2>
            <ul className={styles.persons_list}>
                {goalkeepers.map((person) => (
                    <PersonCard key={person.id.toString()} person={person}/>
                ))}
            </ul>

            <h2>Defenders</h2>
            <ul className={styles.persons_list}>
                {defenders.map((person) => (
                    <PersonCard key={person.id.toString()} person={person} />
                ))}
            </ul>

            <h2>Midfielders</h2>
            <ul className={styles.persons_list}>
                {midfielders.map((person) => (
                    <PersonCard key={person.id.toString()} person={person} />
                ))}
            </ul>

            <h2>Forwards</h2>
            <ul className={styles.persons_list}>
                {forwards.map((person) => (
                    <PersonCard key={person.id.toString()} person={person} />
                ))}
            </ul>
        </div>
    )
}

export default TeamPageSquad;